import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GovernmentAgenyHubAppStandalone } from "./GovernmentAgenyHubAppStandalone";

function render() {
    createRoot(
        document.getElementById("government-agency-hub-app-root")!,
    ).render(
        <StrictMode>
            <GovernmentAgenyHubAppStandalone />
        </StrictMode>,
    );
}

async function startMockWorker() {
    // Dev-only: the MSW worker diverts the ICE SDK calls to the mock server
    // (see src/mocks/browser.ts). It must be active BEFORE the render, or the
    // first policy evaluations would slip past the interception. The dynamic
    // import keeps msw out of the build bundles.
    if (!import.meta.env.DEV) return;
    const { worker } = await import("./mocks/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
}

// If the worker fails to start (a stale generated worker script, an insecure
// origin, service workers blocked), the app must render anyway: without mocks
// the policies stay fail-closed, whereas a blank page would show nothing at all.
startMockWorker()
    .catch((error) => {
        console.error(
            "[mocks] failed to start the service worker, starting the app without mocks:",
            error,
        );
    })
    .finally(render);
